import Campaigns from './components/Campaigns';

export default Campaigns;
